import React from "react";
import { preferredLocationSelector } from "tsi-common-react/src/apps/common/selectors";
import {
    useAppDispatch,
    useAppSelector,
} from "tsi-common-react/src/apps/reducers";
import {
    setFocusedStore,
    updateStoreFilters,
} from "tsi-common-react/src/apps/retail/reducers";
import {
    filteredStoreSelector,
    focusedStoreIDSelector,
} from "tsi-common-react/src/apps/retail/selectors";
import { useMountEffect } from "tsi-common-react/src/hooks/useMountEffect";
import { check } from "tsi-common-react/src/models/utils";

import { DistanceFilter } from "../components/LocatorFilters_Distance";
import { LocationFilter } from "../components/LocatorFilters_Location";
import { LocatorNearestStores as LocatorNearestStoresComponent } from "../components/LocatorNearestStores";
import { FeaturedRetailerLocationsBlockConfig } from "../models";

const parseConfigJSON = (
    configJSON: string,
): FeaturedRetailerLocationsBlockConfig => {
    const data = check(
        FeaturedRetailerLocationsBlockConfig.decode(JSON.parse(configJSON)),
    );
    return data;
};

export const FeaturedRetailerLocations = (props: {
    configJSON: string;
}): React.ReactNode => {
    const filterValues = useAppSelector((state) => state.retail.storeFilters);
    const currentLocation = useAppSelector(preferredLocationSelector);
    const filteredStores = useAppSelector(filteredStoreSelector);
    const focusedStoreID = useAppSelector(focusedStoreIDSelector);
    const dispatch = useAppDispatch();

    const config = parseConfigJSON(props.configJSON);

    useMountEffect(() => {
        dispatch(
            updateStoreFilters({
                retailerName: config.displayed_retailers,
            }),
        );
    });

    return (
        <div className="locator">
            <section className="default-form-container bh-sl-form-container filters l-capped-width">
                <p className="filters__filters">
                    {/* TODO(i18n): Use jt to keep sentence together with interpolated components: jt`${count} results for ${retailerName} within ${distanceFilter} of ${locationFilter}` */}
                    <span className="filters__results">
                        <strong className="bh-sl-total-results">
                            {filteredStores.length}
                        </strong>{" "}
                        results
                    </span>{" "}
                    for {config.retailer_name} within{" "}
                    <DistanceFilter
                        filterValues={filterValues}
                        onChange={(filters) =>
                            dispatch(updateStoreFilters(filters))
                        }
                    />{" "}
                    of{" "}
                    <LocationFilter
                        filterValues={filterValues}
                        currentLocation={currentLocation}
                        onChange={(filters) =>
                            dispatch(updateStoreFilters(filters))
                        }
                    />
                </p>
            </section>
            <section className="locations l-capped-width">
                <LocatorNearestStoresComponent
                    stores={filteredStores}
                    focusedStoreID={focusedStoreID}
                    onSelectStore={(externalID) =>
                        dispatch(setFocusedStore({ externalID }))
                    }
                    showMore={false}
                    disableGrouping={true}
                    noResultsText={config.retailer_name}
                />
            </section>
        </div>
    );
};
